import { render, staticRenderFns } from "./invite-register-maskex.vue?vue&type=template&id=6c84a9a4&"
import script from "./invite-register-maskex.vue?vue&type=script&lang=js&"
export * from "./invite-register-maskex.vue?vue&type=script&lang=js&"
import style0 from "./invite-register-maskex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports